export default __webpack_public_path__ + "static/Aamaal-01-c6bd475160fef9c9de0d1382af7faa5e.webp";